var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonCar',{attrs:{"car_model":_vm.car_model}})
}
var staticRenderFns = []

export { render, staticRenderFns }